import posthog from 'posthog-js';
import { SITE_CONFIG } from '@/config/site';

let initialized = false;

/**
 * Initialize PostHog analytics (optional)
 * Only initializes if VITE_POSTHOG_KEY is set
 */
export function initAnalytics() {
  if (initialized || !SITE_CONFIG.POSTHOG_KEY) {
    return;
  }

  try {
    posthog.init(SITE_CONFIG.POSTHOG_KEY, {
      api_host: SITE_CONFIG.POSTHOG_HOST,
      autocapture: true,
      capture_pageview: true,
      persistence: 'localStorage',
    });

    // Register global properties
    posthog.register({
      utm_source: SITE_CONFIG.UTM_SOURCE,
      site_type: 'cloak',
    });

    initialized = true;
    console.log('[Analytics] Initialized with UTM source:', SITE_CONFIG.UTM_SOURCE);
  } catch (error) {
    console.error('[Analytics] Failed to initialize:', error);
  }
}

/**
 * Track a page view
 */
export function trackPageView(pageName: string, properties?: Record<string, unknown>) {
  if (!initialized) return;

  posthog.capture('$pageview', {
    page_name: pageName,
    utm_source: SITE_CONFIG.UTM_SOURCE,
    url: window.location.href,
    path: window.location.pathname,
    referrer: document.referrer,
    ...properties,
  });
}

/**
 * Track a custom event
 */
export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  if (!initialized) return;

  posthog.capture(eventName, {
    utm_source: SITE_CONFIG.UTM_SOURCE,
    ...properties,
  });
}

/**
 * Track redirect to main site
 */
export function trackRedirect(destination: string, params?: Record<string, string | undefined>) {
  if (!initialized) return;

  posthog.capture('redirect_to_main', {
    destination,
    params,
    utm_source: SITE_CONFIG.UTM_SOURCE,
    from_url: window.location.href,
  });
}

export const Analytics = {
  init: initAnalytics,
  trackPageView,
  trackEvent,
  trackRedirect,
};
